import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Image} from '@udemy/react-core-components';

import styles from './banner.module.less';

const bannerImageDesktop =
    'https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/role-play/roleplay-topics-image-840x600.png';
const bannerImageMobile =
    'https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/role-play/roleplay-topics-image-420x300.png';

export const Banner: React.FC = () => {
    const {gettext} = useI18n();

    return (
        <div className={styles['container']}>
            <div className={classNames('ud-container', styles.banner)}>
                <div className={styles['banner-header']}>
                    <h1 className={'ud-heading-serif-xxl'}>
                        {gettext('Turn learning into real-world practice with Role Play')}
                    </h1>
                    <p className={'ud-text'}>
                        {gettext(
                            'Knowing and doing are not the same. Role Play is your chance to put new skills to the test before it counts. Step into realistic scenarios right after you learn, practice with an AI-powered avatar, get feedback, and go again until it clicks.',
                        )}
                    </p>
                </div>

                <div className={styles['banner-image-container']}>
                    <Image
                        alt=""
                        className={styles['banner-image']}
                        src={bannerImageDesktop}
                        srcSet={`${bannerImageMobile} 420w, ${bannerImageDesktop} 840w`}
                        sizes="(max-width: 767px) 420px, 840px"
                        height={300}
                        width={420}
                    />
                </div>
            </div>
        </div>
    );
};
